import React from 'react';
import classNames from 'classnames';

import IconPrevArrow from '../IconPrevArrow/IconPrevArrow';
import IconNextArrow from '../IconNextArrow/IconNextArrow';

import css from './SliderArrowControls.module.css';

const SliderArrowControls = ({
  className = null,
  buttonClassName = null,
  iconClassName = null,
  leadingContent = null,
  leadingContentClassName = null,
  onPrev = () => {},
  onNext = () => {},
  isPrevDisabled = false,
  isNextDisabled = false,
  prevLabel = 'Previous slide',
  nextLabel = 'Next slide',
}) => {
  return (
    <div className={classNames(css.root, className)}>
      {leadingContent ? (
        <div className={classNames(css.leadingContent, leadingContentClassName)}>
          {leadingContent}
        </div>
      ) : null}
      <button
        type="button"
        className={classNames(css.button, buttonClassName)}
        onClick={onPrev}
        disabled={isPrevDisabled}
        aria-label={prevLabel}
      >
        <IconPrevArrow className={classNames(css.icon, iconClassName)} />
      </button>
      <button
        type="button"
        className={classNames(css.button, buttonClassName)}
        onClick={onNext}
        disabled={isNextDisabled}
        aria-label={nextLabel}
      >
        <IconNextArrow className={classNames(css.icon, iconClassName)} />
      </button>
    </div>
  );
};

export default SliderArrowControls;
